import { computed } from '@nuxtjs/composition-api'
import { AgnosticAttribute, productGetters } from '~/composables/propeller/getters'
import { ProductArg } from '~/types/propeller'

export function firstAttribute (product: ProductArg, attribute: string): AgnosticAttribute | undefined {
  return productGetters.getAttributes(product, [attribute])[0] as AgnosticAttribute | undefined
}

export function useAttribute (product: ProductArg, attribute: string) {
  return computed(() => firstAttribute(product, attribute)?.value)
}

export function useListAttribute (product: ProductArg, attribute: string) {
  return computed<string[]>(() => {
    const value = firstAttribute(product, attribute)?.value

    if (!value || typeof value !== 'string') {
      return []
    }

    return value.split(',')
  })
}
